import { MarketSortOption } from '@/constants/sort';
import apiClient from '../../apiClient';

export type ReqGetBestProducts = {
  query: {
    isPickUp?: boolean;
    isDeliveryFree?: boolean;
    isDiscount?: boolean;
    minPrice?: number;
    maxPrice?: number;
    province?: string;
    city?: string;
    villageName?: string;
    sortOption?: MarketSortOption | null;
  };
  page?: number;
  /** Spring Pageable 바인딩. 미지정 시 서버 기본값 20건. */
  size?: number;
};

export interface BestProductBaseContent {
  id: number;
  createdAt: string;
  platformType: string;
  villageName: string;
  categoryId: string;
  categoryName: string;
  marketProductName: string;
  approvalStatus: string;
  businessName: string;
  originPrice: number;
  price: number;
  discountRate: number;
  thumbnailUrl: string;
  deliveryFee: number;
  isDeliveryFree: boolean;
  label: string;
  tagList: string[];
  state: string;
  isPickUp: boolean;
  stockAvailable: number;
  salesCount: number;
  reviewRate: number;
  // BE는 DEFAULT/Legacy(null)만 노출하지만, FE 방어 필터에서 사용. (filterListableProducts 참고)
  optionType?: 'DEFAULT' | 'OPTION' | 'ADDON' | null;
}

export type ResGetBestProducts = PaginationResponse<BestProductBaseContent>;

const getBestProducts = async ({
  page,
  size,
  query,
}: ReqGetBestProducts): Promise<ResGetBestProducts> => {
  // URLSearchParams를 사용하여 쿼리 문자열 생성
  const params = new URLSearchParams();
  if (page !== undefined) {
    params.append('page', page.toString());
  }
  if (size !== undefined) {
    params.append('size', size.toString());
  }

  // query 객체의 각 속성을 개별 쿼리 파라미터로 추가
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, value.toString()); // 숫자나 불리언 값도 문자열로 변환
    }
  });

  params.append('platformType', 'GROUND');
  // API 호출에 쿼리 문자열 추가
  const { data } = await apiClient.get<ResGetBestProducts>(
    `/app/market-products/best?${params.toString()}`
  );

  return data;
};

export default getBestProducts;
